export default __webpack_public_path__ + "static/media/login_background.ad6ae077.svg";